import { useState } from "react";
import "./Services.css";
import { FaArrowRight, FaArrowUp } from "react-icons/fa";
import { Container } from "react-bootstrap";
import aibg from "../../assets/images/aibg.webp";
import tailored from "../../assets/images/tailored.webp";
import responsible from "../../assets/images/responsible.webp";
import evolving from "../../assets/images/evolving.webp";


const services = [
  {
    id: 1,
    title: "AI-Driven Business Transformation",
    description:
      "Discover AI-driven opportunities across every business function for smarter operations and agile decision-making.",
    image: aibg,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 2,
    title: "Tailored Industry Solutions",
    description: "Deploy AI models designed for sector-specific challenges.",
    image: tailored,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 3,
    title: "Commitment to Responsible AI",
    description:
      "Uphold ethical AI practices with transparency, fairness, and regulatory alignment.",
    image: responsible,
    url: "/services/ai-cybersecurity",
  },
  {
    id: 4,
    title: "Evolving AI Expertise",
    description:
      "Continuously refine AI capabilities to adapt and lead in an evolving landscape.",
    image: evolving,
    url: "/services/ai-cybersecurity",
  },
];

export default function ServicesSection() {
  const [background, setBackground] = useState(services[0].image);
  const [hovered, setHovered] = useState(null);

  return (
    <Container fluid className="p-0">
      <section className="services-container">
        {/* <Container style={{maxWidth:"1400px"}}> */}
        <h1
          className="centered-title mob-title section-title"
          style={{
            margin: "auto",
            padding: "50px",
            position: "absolute",
            color: "white",
          }}
        >
          Strategic AI. Seamless Execution.
        </h1>
        <div
          className="services-wrapper"
          style={{ backgroundImage: `url(${background})` }}
        >
          {services.map((service) => {
            // Define dynamic colors based on service ID
            const dynamicBgColor =
              service.id % 4 === 1
              ? "rgba(25, 16, 154, 0.75)" // Color 2
                : service.id % 4 === 2
                ? "rgba(95, 12, 117, 0.75)" // Color 1
                : service.id % 4 === 3
                ? "rgba(11, 111, 122, 0.75)" // Color 3
                : "rgba(172, 5, 5, 0.75)"; // Color 4
            return (
              <div
                key={service.id}
                className={`service-item ${
                  hovered === service.id ? "hovered" : ""
                }`}
                onMouseEnter={() => {
                  setBackground(service.image);
                  setHovered(service.id);
                }}
                onMouseLeave={() => setHovered(null)}
                style={{
                  background:
                    hovered === service.id ? dynamicBgColor : "transparent",
                }}
              >
                <div className="service-content">
                  <h4 className="service-title">{service.title}</h4>
                  <p className="service-description">{service.description}</p>
                  <span className="service-icon">
                    {hovered === service.id ? (
                      <FaArrowUp className="hovered-arrow" />
                    ) : (
                      <FaArrowRight />
                    )}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        {/* </Container> */}
    
      </section>
    </Container>
  );
}
